<script>
    export default {
        inserted: function (element) {
            element.focus();
        }
    };
</script>